/*Flexi Box Bundle Script Code - Modified with Quantity Selector & Line Item Properties*/

document.addEventListener('DOMContentLoaded', function () {
  // Cache DOM elements
  const flexiBundleRoot = document.querySelector('.flexi-box-bundle');
  const checkboxes = document.querySelectorAll("input[type='checkbox']");
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const submitBtn = document.getElementById('submit-btn');
  const counterEl = document.getElementById('total_product_count');
  const flexiBoxForm = document.getElementById('flexi-box-form');
  const hideQuantityFeature = flexiBundleRoot?.dataset.hideQuantityFeature === 'true';

  // Enable checkboxes after page load
  checkboxes.forEach(checkbox => checkbox.disabled = false);

  // Persist selected items across navigation (e.g. checkout, then back
  // button) so the customer doesn't lose their picks. Scoped per-page via
  // location.pathname since each bundle page has its own product set.
  const SELECTION_STORAGE_KEY = 'flexiBundleSelection:' + location.pathname;

  function saveSelectionState() {
    const selectedIds = Array.from(checkboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.id);
    try {
      localStorage.setItem(SELECTION_STORAGE_KEY, JSON.stringify(selectedIds));
    } catch (e) {
      // Storage unavailable (private mode, quota, etc.) - fail silently.
    }
  }

  // A plain refresh/fresh visit should start empty; only a back/forward
  // navigation (e.g. hitting "back" from the Shopify checkout page) should
  // bring the selection back.
  function isBackForwardNavigation() {
    const [entry] = performance.getEntriesByType('navigation');
    if (entry) return entry.type === 'back_forward';
    // Older browsers without the Navigation Timing L2 API.
    return performance.navigation?.type === performance.navigation?.TYPE_BACK_FORWARD;
  }

  function restoreSelectionState() {
    if (!isBackForwardNavigation()) {
      try {
        localStorage.removeItem(SELECTION_STORAGE_KEY);
      } catch (e) {
        // Storage unavailable - nothing to clear.
      }
      return;
    }

    let selectedIds;
    try {
      selectedIds = JSON.parse(localStorage.getItem(SELECTION_STORAGE_KEY) || '[]');
    } catch (e) {
      return;
    }
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) return;

    let restoredAny = false;
    selectedIds.forEach(id => {
      if (typeof mandatoryProducts !== 'undefined' && calculateTotalQuantity() >= mandatoryProducts) return;

      const checkbox = document.getElementById(id);
      const productInfo = checkbox?.closest('.collection-item');
      if (!checkbox || checkbox.checked || !productInfo) return;

      activateProductSelection(productInfo, checkbox);
      restoredAny = true;
    });

    // activateProductSelection sets checkbox.checked directly (no native
    // click), so it never fires a 'change' event. The sticky bar/popup
    // (new-flexi-box-sticky.js) only rebuilds its Buy Now button and
    // product list in response to that event on checkboxes, so without
    // this dispatch it stays stuck showing the empty/disabled state even
    // though items were actually restored.
    if (restoredAny) {
      const anyCheckbox = document.querySelector("input[type='checkbox']");
      anyCheckbox?.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Crazy-deal cards use a real <button class="crazy-add-btn"> sitting next to
  // an invisible checkbox for accessibility/tap ergonomics. The button just
  // forwards its click to the checkbox (which stays the single source of
  // truth used everywhere else — quantity JS below, the popup, and checkout).
  // Text/disabled styling is driven by the checkbox's live :checked/:disabled
  // state via CSS sibling selectors, except the button's own `disabled`
  // attribute (for real native click-blocking + a11y), which we mirror here.
  document.querySelectorAll('.crazy-add-btn').forEach(btn => {
    const checkbox = btn.previousElementSibling;
    if (!checkbox || checkbox.type !== 'checkbox') return;

    btn.disabled = checkbox.disabled;

    btn.addEventListener('click', () => {
      if (checkbox.disabled) return;
      checkbox.click();
    });

    new MutationObserver(() => {
      btn.disabled = checkbox.disabled;
    }).observe(checkbox, { attributes: true, attributeFilter: ['disabled'] });
  });

  // Global counter for total selected quantity
  let totalQuantitySelected = 0;

  function getSingleItemQuantity(input) {
    return Math.min(parseInt(input.value, 10) || 0, 1);
  }

  // Helper: Calculate total quantity
  function calculateTotalQuantity() {
    let total = 0;
    quantityInputs.forEach(input => total += getSingleItemQuantity(input));
    return total;
  }

  // Bubble counter update function
  function updateBubbleCounter() {
    if (!counterEl) return;

    totalQuantitySelected = calculateTotalQuantity();
    const isLimitReached = (totalQuantitySelected === mandatoryProducts);
    
    counterEl.classList.remove('limit-reached', 'active-limit-reached');
    
    if (isLimitReached) {
      counterEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff" stroke="#fff" stroke-width="0.5"/></svg>`;
      counterEl.classList.add('active-limit-reached');
    } else if (totalQuantitySelected > 0) {
      counterEl.textContent = totalQuantitySelected;
    } else {
      counterEl.textContent = '';
    }
  }

  // Store the initial input values of checkboxes in an object on page load
  const initProdValues = {};
  checkboxes.forEach(checkbox => {
    initProdValues[checkbox.id] = checkbox.value.trim();
  });

  // Helper: Show product added indicators
  function showAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter, .selected-badge").forEach(el => el.classList.remove("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.add("is-active"));
  }

  // Helper: Hide product added indicators
  function hideAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter, .selected-badge").forEach(el => el.classList.add("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.remove("is-active"));
  }

  // Helper: Show notification message
  function showNotificationMessage(productTitle) {
    document.querySelectorAll(".message-bar").forEach(bar => {
      bar.classList.remove("is-hidden");
      const span = bar.querySelector("p span");
      if (span) span.textContent = productTitle;
      setTimeout(() => {
        bar.classList.add("is-hidden");
        if (span) span.textContent = "";
      }, 2500);
    });
  }

  function activateProductSelection(productInfo, checkbox, options = {}) {
    const quantityInput = productInfo?.querySelector('.quantity-input');
    if (!productInfo || !checkbox || !quantityInput) return;

    checkbox.checked = true;
    quantityInput.value = 1;

    if (hideQuantityFeature) {
      productInfo.querySelector('.quantity-selector')?.classList.add('hidden');
      checkbox.closest('.add-to-box')?.classList.remove('hidden');
    } else {
      checkbox.closest('.add-to-box')?.classList.add('hidden');
      productInfo.querySelector('.quantity-selector')?.classList.remove('hidden');
    }

    updateProductCounter(quantityInput);
    createLineItems(quantityInput);
    showAddedIndicators(productInfo);

    if (options.showNotification) {
      const productTitle = checkbox.value.split('/')[0];
      showNotificationMessage(productTitle);
    }

    updateAllStates();
  }

  function deactivateProductSelection(productInfo, options = {}) {
    const quantityInput = productInfo?.querySelector('.quantity-input');
    const checkbox = productInfo?.querySelector("input[type='checkbox']");
    if (!productInfo || !quantityInput || !checkbox) return;

    quantityInput.value = 0;
    checkbox.checked = false;
    productInfo.querySelector('.quantity-selector')?.classList.add('hidden');
    checkbox.closest('.add-to-box')?.classList.remove('hidden');

    hideAddedIndicators(productInfo);
    removeAllLineItems(quantityInput);

    if (options.updateStates !== false) {
      updateAllStates();
    }
  }

  // Checkbox click functionality - switches to quantity selector
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("click", function () {
      const initProductValue = initProdValues[this.id];
      const currProductValue = this.value.trim();
      
      if (currProductValue !== initProductValue) {
        location.reload();
        return;
      }

      const productInfo = this.closest(".collection-item");
      if (!productInfo) return;

      if (this.checked) {
        activateProductSelection(productInfo, this, { showNotification: true });
      } else {
        deactivateProductSelection(productInfo);
      }
    });
  });

  // Quantity selector functionality
  document.addEventListener('click', function(e) {
    const isPlus = e.target.classList.contains('quantity-plus');
    const isMinus = e.target.classList.contains('quantity-minus');
    if (!isPlus && !isMinus) return;

    const input = isPlus ? e.target.previousElementSibling : e.target.nextElementSibling;
    if (!input) return;

    const currentValue = getSingleItemQuantity(input);

    if (isPlus) {
      input.value = 1;
      updateProductCounter(input);
      createLineItems(input);
      updateAllStates();
      return;
    }

    if (currentValue === 1) {
      resetProductToCheckbox(input);
    }
  });

  // Helper: Reset product to checkbox
  function resetProductToCheckbox(input) {
    const productInfo = input.closest('.collection-item');
    if (!productInfo) return;

    deactivateProductSelection(productInfo);
  }

  // Unified update function - calls all necessary updates
  function updateAllStates() {
    updateBubbleCounter();
    updateSubmitButton();
    updateCheckboxAndQuantityStates();
    saveSelectionState();
  }

  // Update product counter display
  function updateProductCounter(input) {
    const counter = input.closest('.collection-item')?.querySelector('.product_counter');
    if (counter) counter.textContent = getSingleItemQuantity(input);
  }

  // Create line items for the product
  function createLineItems(input) {
    const quantity = getSingleItemQuantity(input);
    const property = input.getAttribute('data-property');
    const itemId = input.getAttribute('data-id');
    
    if (!property || !itemId || !flexiBoxForm) return;

    input.value = quantity;
    removeAllLineItems(input);

    for (let i = 1; i <= quantity; i++) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = `properties[_ITEM${itemId}_${i}]`;
      hiddenInput.value = property;
      hiddenInput.className = `line-item-${itemId}`;
      flexiBoxForm.appendChild(hiddenInput);
    }
  }

  // Remove one line item
  function removeLineItem(input) {
    const itemId = input.getAttribute('data-id');
    if (!itemId) return;

    const lineItems = document.querySelectorAll(`.line-item-${itemId}`);
    if (lineItems.length > 0) {
      lineItems[lineItems.length - 1].remove();
    }
  }

  // Remove all line items for a product
  function removeAllLineItems(input) {
    const itemId = input.getAttribute('data-id');
    if (!itemId) return;

    document.querySelectorAll(`.line-item-${itemId}`).forEach(item => item.remove());
  }

  // Update checkbox and quantity button states based on total quantity
  function updateCheckboxAndQuantityStates() {
    const total = calculateTotalQuantity();
    const isLimitReached = (typeof mandatoryProducts !== 'undefined' && total >= mandatoryProducts);

    // Disable/enable unchecked checkboxes
    checkboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        const parentItem = checkbox.closest('.collection-item');
        if (parentItem) {
          // Get the quantity value for this item
          const quantityInput = parentItem.querySelector('.quantity-input');
          const itemQuantity = quantityInput ? getSingleItemQuantity(quantityInput) : 0;
          
          // Only disable if item has no quantity
          const shouldDisable = isLimitReached && itemQuantity === 0;
          checkbox.disabled = shouldDisable;
          parentItem.classList.toggle('disabled-item', shouldDisable);
        }
      }
    });

    // Always disable quantity plus buttons because each item can only be selected once.
    document.querySelectorAll('.quantity-plus').forEach(btn => {
      btn.disabled = true;
      btn.classList.add('disabled');
    });
  }

  // Update submit button visibility
  function updateSubmitButton() {
    if (!submitBtn) return;

    const total = calculateTotalQuantity();
    submitBtn.style.display = (typeof mandatoryProducts !== 'undefined' && total === mandatoryProducts) ? 'inline-block' : 'none';
  }

  // Disable right-click context menu
  document.addEventListener("contextmenu", e => e.preventDefault());

  // Disable F12 key (Inspect Element)
  document.addEventListener("keydown", e => {
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
  });

  // Initial state check on page load
  quantityInputs.forEach((input) => {
    const normalizedQuantity = getSingleItemQuantity(input);
    input.value = normalizedQuantity;

    if (normalizedQuantity > 0) {
      createLineItems(input);
      updateProductCounter(input);
    }
  });

  // Re-select whatever the customer had picked before navigating away
  // (e.g. to checkout) so their selection survives a return visit.
  restoreSelectionState();

  updateAllStates();
});

/* Flexi Box Bundle - Shopify Checkout Handler */
window.addEventListener('DOMContentLoaded', () => {
  const submitBtn = document.getElementById('submit-btn');
  const flexiBoxForm = document.getElementById('flexi-box-form');
  const payButtons = [document.getElementById('flexi-pay-now'), document.getElementById('flexi-popup-pay-now')].filter(Boolean);
  let payNowLoadingTimeout = null;
  if (!submitBtn || !flexiBoxForm) return;

  function setPayNowLoading(isLoading) {
    payButtons.forEach((button) => {
      if (!button.dataset.originalHtml) {
        button.dataset.originalHtml = button.innerHTML;
      }

      if (isLoading) {
        button.innerHTML = '<span class="flexi-pay-loader" aria-hidden="true">Loading...</span>';
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.7';
        button.setAttribute('aria-busy', 'true');
      } else {
        button.innerHTML = button.dataset.originalHtml;
        button.style.pointerEvents = 'auto';
        button.style.opacity = '1';
        button.removeAttribute('aria-busy');
      }
    });
  }

  function resetCheckoutState() {
    if (payNowLoadingTimeout) {
      clearTimeout(payNowLoadingTimeout);
      payNowLoadingTimeout = null;
    }

    window.flexi_bundle_already_processing = false;
    submitBtn.removeAttribute('aria-disabled');
    submitBtn.classList.remove('loading');
    setPayNowLoading(false);
  }

  function startCheckoutLoadingWindow() {
    if (payNowLoadingTimeout) {
      clearTimeout(payNowLoadingTimeout);
    }

    payNowLoadingTimeout = window.setTimeout(() => {
      resetCheckoutState();
    }, 2000);
  }

  function getSelectedVariantIds() {
    const checkedInputs = flexiBoxForm.querySelectorAll('input[type="checkbox"]:checked');
    const variantIds = [];

    checkedInputs.forEach((input) => {
      if (input.value === 'No') return;

      const productInfo = input.closest('.collection-item');
      const variantId = productInfo?.dataset.variantId;
      if (!variantId) return;

      variantIds.push(variantId);
    });

    return variantIds;
  }

  async function submitToShopifyCheckout() {
    const variantIds = getSelectedVariantIds();
    if (variantIds.length === 0) {
      throw new Error('No products selected');
    }

    const clearCartResponse = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!clearCartResponse.ok) {
      throw new Error('Unable to clear cart before checkout');
    }

    const addToCartResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: variantIds.map((id) => ({ id, quantity: 1 })),
      }),
      credentials: 'same-origin',
    });

    if (!addToCartResponse.ok) {
      throw new Error('Unable to add selected products to cart before checkout');
    }

    window.location.assign('/checkout');
  }

  window.flexiStartCheckout = async function flexiStartCheckout() {
    if (window.flexi_bundle_already_processing) {
      return;
    }

    window.flexi_bundle_already_processing = true;
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    setPayNowLoading(true);
    startCheckoutLoadingWindow();

    try {
      await submitToShopifyCheckout();
    } catch (error) {
      console.error(error);
      alert('Unable to start checkout. Please try again.');
      resetCheckoutState();
    }
  };

  resetCheckoutState();

  window.addEventListener('pageshow', () => {
    resetCheckoutState();
  });

  submitBtn.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();

    await window.flexiStartCheckout();
  }, true);
});

















